import React from 'react';
import { getAdminApiUrl } from '@adsk/acs-sc-web-platform-api';
import { UndoIcon, StorageBoxIcon } from '@adsk/alloy-react-icon';

export const adminAccountChangeProjectStatusRequest = (projectId, status) => [
  `${getAdminApiUrl()}/v1/projects/${projectId}`,
  {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ status }),
  },
];

export const getAccountProjectOptionsMenuItems = (
  projectStatus,
  archiveLabel,
  restoreLabel
) => [
  {
    itemOptions: [
      ...(projectStatus === 'archived'
        ? [
            {
              renderIcon: () => <UndoIcon style={{ marginRight: '8px' }} />,
              key: 'restore',
              label: restoreLabel,
              onClick: (e) => e.stopPropagation(),
            },
          ]
        : [
            {
              renderIcon: () => (
                <StorageBoxIcon style={{ marginRight: '8px' }} />
              ),
              key: 'archive',
              label: archiveLabel,
              onClick: (e) => e.stopPropagation(),
            },
          ]),
    ],
    key: 'actions',
    showSelection: false,
    title: '',
  },
];
